import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  IncidentReport,
  IncidentReportSearchRequest,
  IncidentReportSearchResponse,
  IncidentReportStats,
} from "./@types";

export const incidentReportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIncidentReports: builder.mutation<
      ApiSuccessResponse<IncidentReportSearchResponse>,
      IncidentReportSearchRequest
    >({
      query: (data) => ({
        url: "/v1/accidentreports/history",
        method: "POST",
        body: { ...data },
      }),
    }),
    getIncidentReportStats: builder.query<
      ApiSuccessResponse<IncidentReportStats>,
      void
    >({
      query: () => ({
        url: "/v1/accidentreports/statistics",
        method: "GET",
      }),
    }),
    addIncidentReport: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/accidentreports",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateIncidentReport: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/v1/accidentreports/update${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    getIncidentReportById: builder.query<
      ApiSuccessResponse<IncidentReport>,
      string
    >({
      query: (id) => ({
        url: `/v1/accidentreports//${id}`,
        method: "GET",
      }),
    }),
    deleteIncidentReport: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/accidentreports/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetIncidentReportsMutation,
  useGetIncidentReportStatsQuery,
  useAddIncidentReportMutation,
  useUpdateIncidentReportMutation,
  useGetIncidentReportByIdQuery,
  useDeleteIncidentReportMutation,
} = incidentReportApiSlice;
